import React from "react";
import styles from "@/components/LanguageModelArtifact/style.module.css";
const NoModelsAvailableTile = ({ modelViewType }) => {
    return (React.createElement("div", { className: styles.noModelsAvailableTileWide },
        React.createElement("div", { className: styles.noModelsTitle }, modelViewType === "TRAINING_JOBS" ? "No Post Training Jobs Available" : "No Models Available"),
        React.createElement("div", null, "Once one has been created it will be displayed here")));
};
export default NoModelsAvailableTile;
